<template>
  <div class="pop-auth">
    <div class="pop-auth__main">
      <div class="pop-auth__card">
        <div class="pop-auth__logo"><auth-logo /></div>
        <slot></slot>
      </div>
      <div v-if="$slots.footer" class="pop-auth__footer"><slot name="footer"></slot></div>
    </div>
    <div class="pop-auth__aside"><auth-aside /></div>
  </div>
</template>

<script>
import AuthLogo from './AuthLogo.vue'
import AuthAside from './AuthAside.vue'

// Split auth layout of the signup/login redesign: white card on the left over #F5F8F8,
// gradient aside with rotating testimonials on the right (hidden under 980px).
export default {
  name: 'AuthLayout',
  components: { AuthLogo, AuthAside },
}
</script>

<style lang="scss">
/* Unscoped on purpose: these classes are shared by every auth page. */
@import './auth.scss';
</style>
